<template>
  <div class="ordinaryModify">
    <el-dialog
      :popper-append-to-body="false"
      center
      :title="'现货列表' + '(' + modifyingReplication.styleNumber + ')'"
      :close-on-click-modal="false"
      :visible.sync="plainGoldSpotDialogVisible"
      :before-close="handleClose"
    >
      <el-table
        :data="gridData"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 100%"
      >
        <el-table-column property="barCode" label="商品条码"></el-table-column>

        <el-table-column
          property="generaName"
          label="大类名称"
        ></el-table-column>
        <el-table-column
          property="productName"
          label="商品名称"
        ></el-table-column>
        <el-table-column property="goldWeigh" label="金重"></el-table-column>
        <!-- <el-table-column
					property="tradePrice"
					v-if="
						!hasPermission('展厅') ||
							!hasPermission('加盟公司总经理')
					"
					label="批发价格(以实际出货价为准):"
				></el-table-column>
				<el-table-column
					property="labelPrice"
					label="标签价格"
				></el-table-column>
				<el-table-column
					property="enjoyLabelPrice"
					label="尊享价"
				></el-table-column> -->
        <el-table-column property="ringSize" label="规格"></el-table-column>
        <el-table-column
          property="bigSeriesName"
          label="大系列名称"
        ></el-table-column>
        <el-table-column
          property="laborCost"
          v-if="!hasPermission('展厅') || !hasPermission('加盟公司总经理')"
          label="批发克工费"
        ></el-table-column>
        <el-table-column
          property="sellingLaborCost"
          label="销售克工费"
        ></el-table-column>
        <el-table-column
          property="seriesName"
          label="系列名称"
        ></el-table-column>
      </el-table>
      <div class="pageClass">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="listQuery.current"
          :page-size="listQuery.size"
          @current-change="cartSpotListCurrentPage($event)"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSpot } from '@/api/orderApi'
import { cutFilter } from '@/utils/filetrs'
export default {
  props: {
    plainGoldSpotDialogVisible: Boolean,
    modifyingReplication: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      listQuery: {
        id: '',
        current: 1,
        size: 5,
        styleNumber: this.modifyingReplication.styleNumber,
      },
      total: 0,
      gridData: [],
    }
  },
  filters: {
    cutFilter,
  },
  mounted() {
    this.getSpotList()
  },
  methods: {
    // 获取列表数据
    getSpotList() {
      this.listQuery.id = this.modifyingReplication.id
      getSpot(this.listQuery).then((res) => {
        this.gridData = []
        res.data.records.forEach((item) => {
          this.gridData.push(item)
        })
        this.total = res.data.total
      })
    },
    // 分页
    cartSpotListCurrentPage(ev) {
      this.listQuery.current = ev
      this.getSpotList()
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('onCloseSelectDialog')
    },
  },
}
</script>

<style scoped lang="scss">
.ordinaryModify {
  /deep/.el-dialog {
    width: 1500px;
  }

  /deep/ .el-dialog--center .el-dialog__body {
    padding: 0 10px 10px 10px;
  }

  /deep/.el-table .cell {
    padding: 0;
  }

  .el-button {
    width: 100%;
  }

  .el-button--text {
    color: red;
  }

  .pageClass {
    text-align: center;
    padding: 20px 0;
    background: #fff;
  }
}
</style>
